export default {
    url: '/payers_count_by_days',
    reloadOnSearch: false,
    data: {
        priority: 803,
        title: 'Payers Count By Days',
        role: 'paywalls',
    },
    views: {
        '': {
            template: require('./view.html'),
            controller: [
                '$scope', 'paywalls_api',
                function($scope, paywalls_api) {
                    $scope.get_data_method = paywalls_api.payers_retention_rolling;
                },
            ],
        },
    },
};
